import z from 'zod';

export const DatasetColumnType = z.enum(['string', 'number', 'boolean', 'datetime', 'ref', 'unknown']);
export const ColumnRefKind = z.enum(['entity', 'ts', 'unknown']);

export const DatasetColumn = z.object({
  name: z.string(),
  type: DatasetColumnType,
  refKind: ColumnRefKind.optional(),
  unit: z.string().optional(),
  description: z.string().optional(),
  synthetic: z.boolean().optional(),
});

export const Dataset = z.object({
  rows: z.record(z.string(), z.unknown()).array(),
  columns: DatasetColumn.array(),
});

export type DatasetT = z.infer<typeof Dataset>;
export type DatasetColumnTypeT = z.infer<typeof DatasetColumnType>;
export type DatasetColumnT = z.infer<typeof DatasetColumn>;

// Dataset-reference primitives

export const inputDataset = z
  .string()
  .min(1)
  .describe('Key of a dataset in the top-level `datasets` map, staged by an upstream data-producing tool.');

export const columnRef = z
  .string()
  .min(1)
  .describe(
    'Transformation expression or direct column name (when no transformation needed) to pull from the inputDataset.',
  );
